import(/* webpackMode: "eager" */ "/vercel/path0/my-project/node_modules/next/dist/client/link.js");
